module.exports = __webpack_public_path__ + "ebc8aa49f3d64f3d0d2f631ea29a45db.svg";